import { createColumnHelper } from "@tanstack/react-table";
import * as React from "react";
import { useMemo } from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import Icon from "components/common/Icon";
import { ROW_EXPAND_COL_ID } from "components/common/EntityDataTable/Constants";
import useExpandedSections from "components/common/EntityDataTable/hooks/useExpandedSections";
import getAvailableSectionNames from "components/common/EntityDataTable/getAvailableSectionNames";
const Container = styled.div`
  display: flex;
  justify-content: center;
`;
const ToggleButton = styled(Button)`
  && {
    aspect-ratio: 1;
    padding: 0;
  }
`;
const ToggleIcon = styled(Icon)`
  display: block;
  line-height: 1;
`;
const RowExpandToggle = ({ entityId }) => {
  const { expandedSections, toggleSection } = useExpandedSections();
  const isExpanded = !!(expandedSections == null ? void 0 : expandedSections[entityId]);
  const title = isExpanded ? "Collapse row" : "Expand row";
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      bsStyle: "default",
      bsSize: "xs",
      onClick: () => toggleSection(entityId),
      title,
      "aria-label": title
    },
    /* @__PURE__ */ React.createElement(ToggleIcon, { name: isExpanded ? "keyboard_arrow_down" : "chevron_right" })
  ));
};
const RowExpandCell = ({
  row,
  expandedSectionRenderers
}) => getAvailableSectionNames(expandedSectionRenderers, row.original).length > 0 ? /* @__PURE__ */ React.createElement(RowExpandToggle, { entityId: row.id }) : null;
const useRowExpandColumnDefinition = (expandedSectionRenderers, colWidth) => {
  const columnHelper = createColumnHelper();
  return useMemo(
    () => Object.keys(expandedSectionRenderers != null ? expandedSectionRenderers : {}).length > 0 ? columnHelper.display({
      id: ROW_EXPAND_COL_ID,
      size: colWidth,
      enableHiding: false,
      cell: ({ row }) => /* @__PURE__ */ React.createElement(RowExpandCell, { row, expandedSectionRenderers }),
      enableResizing: false
    }) : null,
    [expandedSectionRenderers, columnHelper, colWidth]
  );
};
export default useRowExpandColumnDefinition;
